module.exports = __webpack_public_path__ + "img/small-logo-central-tanbun-indonesia.14020c8b.png";